import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: el-transition is not typed
import { enter, leave } from 'el-transition'

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = [
    'main',
    'slideout',
  ]

  declare readonly mainTarget: HTMLElement
  declare readonly slideoutTarget: HTMLElement

  show (): void {
    this.mainTarget.classList.remove('hidden')

    // Prevent scrolling when the mobile sidebar is open
    if (this.mainTarget.id === 'mobile-shared-sidebar') {
      document.body.classList.add('overflow-hidden')
    }

    enter(this.slideoutTarget)
  }

  hide (): void {
    leave(this.slideoutTarget).then(() => {
      this.mainTarget.classList.add('hidden')

      // Restore scrolling if we had disabled it for mobile sidebar
      if (this.mainTarget.id === 'mobile-shared-sidebar') {
        document.body.classList.remove('overflow-hidden')
      }
    })
  }
}
